// extracted by mini-css-extract-plugin
module.exports = {"skillSearchBar":"SearchBarSkills_skill-search-bar__1Q4Qp","wrapper":"SearchBarSkills_wrapper__1iDoH","search":"SearchBarSkills_search__2LUw2"};